<template>
    <div class="mt-0">
        <div class="row p-2 mt-3" id="lower-div">
            <div class="card mb-4">
                <div v-loading="loading">
                    <Table @get-data="GetRejectTypes" :data="data"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            firstVis: true,
            loading: null,
            data: [], 
            navNumber: 1
        }
    },
    methods: {
        GetRejectTypes() {
            
            //None
        }
    },
    mounted() {
        this.GetRejectTypes()
    }
}
</script>